import { SVGProps } from "react"

export const RefyIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="48rem" height="48rem" viewBox="0 0 48 48" fill="none"  {...props}>
            <g filter="url(#filter0_d_6074_8957)">
                <rect x="5" y="1" width="38" height="38" rx="18.9789" fill="url(#paint0_radial_6074_8957)" shapeRendering="crispEdges" />
                <rect x="4.5" y="0.5" width="39" height="39" rx="19.4789" stroke="url(#paint1_linear_6074_8957)" shapeRendering="crispEdges" />
            </g>
            <g filter="url(#filter1_d_6074_8957)">
                <circle cx="15.9708" cy="11.9707" r="3.05407" fill="white" />
                <circle cx="31.6124" cy="11.9707" r="3.05407" fill="white" />
            </g>
            <g filter="url(#filter2_d_6074_8957)">
                <path d="M22 15C22 16.1046 22.8954 17 24 17C25.1046 17 26 16.1046 26 15" stroke="white" strokeLinecap="round" />
            </g>
            <defs>
                <filter id="filter0_d_6074_8957" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6074_8957" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6074_8957" result="shape" />
                </filter>
                <filter id="filter1_d_6074_8957" x="10.5607" y="6.56063" width="26.4618" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.178" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6074_8957" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6074_8957" result="shape" />
                </filter>
                <filter id="filter2_d_6074_8957" x="19.144" y="12.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.178" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6074_8957" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6074_8957" result="shape" />
                </filter>
                <radialGradient id="paint0_radial_6074_8957" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(24 19) rotate(90) scale(20)">
                    <stop stopColor="#D9D9D9" />
                    <stop offset="1" />
                </radialGradient>
                <linearGradient id="paint1_linear_6074_8957" x1="24" y1="1" x2="24" y2="39" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#999999" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>

    )
}